import { useEffect, useState } from "react";
import api from "@/lib/api";

// Voor deze talen staan de gastteksten handgeschreven in de code: geen vertaling nodig.
export const BUILTIN_LANGS = ["nl", "es", "de", "en", "no", "da", "fr"];
export const isBuiltinLang = (l) => BUILTIN_LANGS.includes(l);

const cache = new Map();

/** Haalt een set labels in de gevraagde taal. De server vertaalt één keer met AI en
 *  bewaart het resultaat, dus dit is daarna onmiddellijk. */
export function fetchPack(pack, lang, base, context) {
  const key = `${pack}:${lang}`;
  if (!cache.has(key)) {
    cache.set(key, api.post("/doc-pack", { pack, lang, base, context })
      .then((r) => r.data.values)
      .catch((e) => { console.warn(`Vertaling van '${pack}' naar ${lang} mislukt`, e?.message); return base; }));
  }
  return cache.get(key);
}

/** Geeft de vertaalde labels, of null zolang ze onderweg zijn (dan geldt de eigen tekst). */
export function useDocPack(pack, lang, base, context) {
  const [values, setValues] = useState(null);
  useEffect(() => {
    if (!lang || isBuiltinLang(lang)) { setValues(null); return; }
    let on = true;
    fetchPack(pack, lang, base, context).then((v) => on && setValues(v));
    return () => { on = false; };
    // base en context horen bewust niet in de deps: ze horen bij het pakket, niet bij de taal
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pack, lang]);
  return values;
}

export const flattenPairs = (prefix, pairs = []) =>
  pairs.reduce((acc, [a, b], i) => ({ ...acc, [`${prefix}${i}_t`]: a || "", [`${prefix}${i}_b`]: b || "" }), {});

export const unflattenPairs = (prefix, values, count) =>
  Array.from({ length: count }, (_, i) => [values[`${prefix}${i}_t`] || "", values[`${prefix}${i}_b`] || ""]);
